export default {
  IsoDuration: {
    maxDurationError: 'Ошибка валидации. Максимальное значение таймера - {{data}}',
  },
};
